<template>
  <div v-if="total > 0">
    <div class="d-flex align-center">
      <div class="flex-grow-0 pl-4">
        {{ firstIndex }}-{{ lastIndex }}/{{ total }}
      </div>
      <div class="flex-grow-1 d-flex align-center justify-center">
        <v-pagination
          v-model="c_page"
          class="table__paging"
          color="primary"
          :disabled="disabled"
          :length="lengthPaginate"
          :total-visible="isMobile ? 5 : 7"
        ></v-pagination>
      </div>
      <div v-if="!hidePerPage" class="flex-grow-0 pr-4">
        <v-select
          v-model="c_perpage"
          dense
          :disabled="disabled"
          height="30px"
          hide-details
          :items="itemsPerPage"
          single-line
          style="width: 110px"
        ></v-select>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    hidePerPage: Boolean,
    disabled: Boolean,
    page: [String, Number],
    perpage: [String, Number],
    total: [String, Number],
  },
  data: () => ({
    itemsPerPage: [5, 10, 25, 50].map((x) => ({
      text: x + ' / trang',
      value: x,
    })),
    d_perpage: 10,
    d_page: 1,
  }),
  computed: {
    firstIndex() {
      return (this.page - 1) * this.perpage + 1
    },
    lastIndex() {
      let last = this.page * this.perpage
      if (last > this.total) return this.total
      return last
    },
    c_perpage: {
      get() {
        return this.perpage || this.d_perpage
      },
      set(value) {
        this.d_perpage = value
        this.d_page = 1
        this.$emit('update:page', 1)
        this.$emit('update:perpage', value)
        this.submit()
      },
    },
    c_page: {
      get() {
        return this.page || this.d_page
      },
      set(value) {
        this.d_page = value
        this.$emit('update:page', value)
        this.submit()
      },
    },
    lengthPaginate() {
      if (this.total == 0) {
        return 1
      }
      return Math.floor((this.total - 1) / this.perpage) + 1
    },
  },
  methods: {
    submit() {
      let value = {
        page: this.d_page,
        itemsPerPage: this.d_perpage,
      }

      this.$emit('update', value)
    },
  },
}
</script>

<style lang="scss">
.v-application .table__paging {
  button:not(.v-pagination__item--active) {
    color: #374151 !important;
  }
  button {
    padding: 0;
    margin: 0;
    border-radius: 0;
    box-shadow: none;
    border: 1px solid #e0e0e0;
  }
  li button {
    height: 30px;
    min-width: 30px;
    margin: 0px 6px;
  }
}
</style>
